// src/components/BranchSections.js — mandates laid out Fund / Direct Deal
// first, then by work type (Matt, 10/8). Each branch gets a heading with a
// coloured bar, a count and a rule beneath it; each work type sits in an
// indented, outlined panel under its branch. A mandate engaged for more than
// one work type shows in each panel; it is still one mandate (one record).
// Shared by the CRM dashboard and the partner portal; renderGrid draws the
// tiles so each page keeps its own tile.
import { groupByBranch, groupByWorkType } from '../lib/mandateBranch'
import { workTypeLabel, useIsPortal } from '../lib/workTypes'

const BRANCH_COLOR = { FS: 'var(--purple)', DD: 'var(--accent)' }

function Count({ n }) {
  return (
    <span style={{
      fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)',
      background: 'var(--hover-tint)', border: '1px solid var(--border)',
      borderRadius: 999, padding: '1px 9px', letterSpacing: 0,
    }}>{n}</span>
  )
}

function BranchHeading({ label, n, color }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      paddingBottom: 10, marginBottom: 14,
      borderBottom: '1px solid var(--border-light)',
    }}>
      <span style={{ width: 4, height: 20, borderRadius: 2, background: color ?? 'var(--border-light)' }} />
      <h3 className="caps-label" style={{
        margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-primary)',
      }}>{label}</h3>
      <Count n={n} />
    </div>
  )
}

function WorkPanel({ label, n, children }) {
  return (
    <div style={{
      marginLeft: 16, border: '1px solid var(--border)', borderRadius: 10,
      background: 'var(--hover-tint)', padding: '12px 16px 16px',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        paddingBottom: 10, marginBottom: 12, borderBottom: '1px solid var(--border)',
      }}>
        <span className="caps-label" style={{
          fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)',
        }}>{label}</span>
        <Count n={n} />
      </div>
      {children}
    </div>
  )
}

export default function BranchSections({ mandates, renderGrid }) {
  const partner = useIsPortal()
  const groups = groupByBranch(mandates)
  // Nothing has a branch yet (e.g. a pre-EL stage): plain grid, no headings.
  if (groups.length === 1 && groups[0].key === null) return renderGrid(mandates)

  return groups.map((g, i) => {
    const work = groupByWorkType(g.items)
    return (
      <section key={g.label} style={{ marginTop: i ? 28 : 0 }}>
        <BranchHeading label={g.label} n={g.items.length} color={BRANCH_COLOR[g.key]} />
        {work ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {work.map(w => (
              <WorkPanel key={w.label} label={workTypeLabel(w.label, partner)} n={w.items.length}>
                {renderGrid(w.items)}
              </WorkPanel>
            ))}
          </div>
        ) : renderGrid(g.items)}
      </section>
    )
  })
}
